import { contracts } from '../../data/contracts'

export default {
	name: 'TFBX',
	shortName: 'TFBX',
	contractAddress: contracts[process.env.REACT_APP_NETWORK].tfbxAddress,
	url: 'http://lorem.com',
	logo: 'tokens/TFBX.png'
}
